import { z } from 'zod';
import { pagedSchema } from '@/shared/reference/wire';
import { centsToDecimal, decimalToCents } from '@/shared/format/money';

const text = z.string().nullish();
const number = z.number().nullish();
const flag = z.boolean().nullish();
export const payrollAgreementSchema = z.looseObject({
  id: z.string(),
  name: z.string(),
  tenant: text,
  tenantDisplay: text,
  createdAt: text,
  updatedAt: text,
  createdBy: z.looseObject({ userIdDisplay: text.meta({ pii: 'name' }) }).nullish(),
  updatedBy: z.looseObject({ userIdDisplay: text.meta({ pii: 'name' }) }).nullish(),
  warrantyRegistrationOffice: text,
  warrantyRegistrationOfficeDisplay: text,
  employeeSiapeId: text,
  pensionerSiapeId: text,
  apiSettingsId: text,
  numberOfWarranties: number,
  warrantyRegistrationCutoffDay: number,
  paymentTransferDay: number,
  warrantyRegistrationCutoffs: z
    .array(z.object({ month: z.number(), cutoffDay: z.number().nullable() }))
    .nullish(),
  monthsUntilFirstPayment: number,
  minTermInMonths: number,
  maxTermInMonths: number,
  minimumEmploymentMonths: number,
  minimumStartDateEmployerMonths: number,
  allowedMarginPercentage: number,
  minInterestRate: number,
  maxInterestRate: number,
  minimumDownPaymentPercentage: number,
  minimumDownPaymentValue: number,
  ltv: number,
  minAgeAtStartDate: z.union([z.number(), z.string()]).nullish(),
  maxAgeAtLastInstallment: z.union([z.number(), z.string()]).nullish(),
  operationTypes: z.array(z.string()).nullish(),
  employeePositionBlacklist: z.array(z.number()).nullish(),
  employeeCategoryBlacklist: z.array(z.number()).nullish(),
  requiresPasswordForFreeMarginQuery: flag,
  hasWarrantyDataprev: flag,
  allowTransactNegativeMargin: flag,
  allowInterestRateChange: flag,
  allowGracePeriodChange: flag,
  onlineMarginCheck: flag,
  requiresFinanceTaxInformation: flag,
  allowPaymentChange: flag,
});
export type PayrollAgreement = z.infer<typeof payrollAgreementSchema>;
export const payrollAgreementPageSchema = pagedSchema(payrollAgreementSchema);
export const employeePositionSchema = z.looseObject({ code: z.string(), description: z.string() });
export const employeePositionsSchema = z.array(employeePositionSchema);
export type PayrollAgreementWrite = Record<string, unknown> & { id: string; name: string };
export interface PayrollAgreementListParams {
  page?: number | undefined;
  size?: number | undefined;
  searchString?: string | undefined;
  tenant?: string | undefined;
  name?: string | undefined;
  initialDate?: string | undefined;
  finalDate?: string | undefined;
}
export function payrollAgreementListQueryParams(p: PayrollAgreementListParams) {
  return {
    page: p.page,
    size: p.size,
    searchString: p.searchString,
    tenant: p.tenant,
    name: p.name,
    initialDate: p.initialDate,
    finalDate: p.finalDate,
    orderBy: 'createdAt_DESC',
  };
}
// U02/S24: AgreementContainer.tsx:49–73 usa decimal no GET/POST/PUT e centavos no formulário.
export const downPaymentFromWire = (value: number | null | undefined) =>
  value == null ? value : decimalToCents(String(value));
export const downPaymentToWire = (cents: number | null | undefined) =>
  cents == null ? cents : Number(centsToDecimal(cents));
